import { call, put, takeLatest } from 'redux-saga/effects';
import Auth from '../../api/auth';
import { actionTypes, getUserSuccess, getUserWithCodeSuccess } from '../actions/auth';

function* getUser(action) {
  try {
    const user = yield call(Auth.getUser);
    yield put(getUserSuccess(user));
    action.callback(user);
  } catch (error) {
    console.log(error);
    action.callback(null);
  }
}

function* login(action) {
  try {
    const result = yield call(() => Auth.login(action.payload));
    localStorage.setItem('token', result.token);
    localStorage.setItem('refreshToken', result.refreshToken);
    yield put(getUserSuccess(result.user));
    action.callback(true);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* submitEmailForPasswordReset(action) {
  try {
    yield call(() => Auth.submitEmailForPasswordReset(action.payload));
    action.callback(true);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* resetPassword(action) {
  try {
    yield call(() => Auth.resetPassword(action.payload));
    action.callback(true);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

function* logout() {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('isLoggedInWithCode');
    yield put(getUserSuccess({}));
  } catch (error) {
    console.log(error);
  }
}

function* getUserWithCode(action) {
  try {
    const result = yield call(() => Auth.getUserWithCode(action.payload));
    localStorage.setItem('token', result.token);
    localStorage.setItem('refreshToken', result.refreshToken);
    yield put(getUserWithCodeSuccess(result.user));
    action.callback(result.user);
  } catch (error) {
    console.log(error);
    action.callback(null);
  }
}

function* getSignInUrl(action) {
  try {
    yield call(() => Auth.getSignInUrl(action.payload));
    action.callback(true);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

export default function* authSaga() {
  yield takeLatest(actionTypes.GET_USER, getUser);
  yield takeLatest(actionTypes.LOGIN_USER, login);
  yield takeLatest(actionTypes.SEND_EMAIL_FOR_PASSWORD_RESET, submitEmailForPasswordReset);
  yield takeLatest(actionTypes.RESET_PASSWORD, resetPassword);
  yield takeLatest(actionTypes.LOGOUT, logout);
  yield takeLatest(actionTypes.GET_USER_WITH_CODE, getUserWithCode);
  yield takeLatest(actionTypes.GET_SIGN_IN_URL, getSignInUrl);
}
